
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import SetDimension from "./step-view/set-dimension.vue";
import SetTest from "./step-view/set-test.vue";
import SetOther from "./step-view/set-other.vue";
import AskGoOn from "./components/delete-dialog.vue";
import vuexStore from "@/store/vuex-store";
import {
  ExamV2Custom,
  StructExamScoreConfig
} from "@/lib/model/exambuilder/exam-v2";
import Auth from "@/lib/common/auth";
import ExamList from "@/lib/model/exam/exam";
import { ExamGetForm } from "@/lib/form/exam/ExamListForm";
import MsgRequest from "@/lib/model/message/MsgRequest";
import Power from "@/views/paper/components/power.vue";
import AiStepBar from "@/components/layout/ai-worker-step.vue";
import { ExamV3, HeaderOption } from "@/lib/model/workerbuilder/exam-v3";

@Component({
  components: {
    SetDimension,
    SetOther,
    SetTest,
    AskGoOn,
    Power,
    AiStepBar
  }
})
export default class AiBuilderWorker extends Vue {
  pathText = "新建面试";
  stepShow: boolean[] = [false, false, false, false, false]; //四个步骤显隐
  currentStep = 0; //当前步骤 0 1 2 3 4
  vuexStores = vuexStore;
  examGetForm = new ExamGetForm();
  paperId = 0;
  isEdit = false; //是否编辑页面
  dataInited = false;
  askGoOn = false; //是否继续上次的新建流程
  isCandidateUsed = false; //是否有候选人答题
  powerExamId = 0; //设置权限的面试id
  showPower = false;

  // 翻页限制速度，防止点击太快
  canChangePage = true;
  canCancelPage = true;
  pageInterval = 300;
  cancelInterval = 500;

  // 原始分数配置，如果有候选人答完题，则需要使用原始分数配置提交
  originScoreConfigList: StructExamScoreConfig[] | null = null;

  videoUrlDef =
    "https://vod.hina.com/a3309d04251940faa56806be59bdf122/8c7be05066f64d29ae74ffbd5500daa9-ca173c7e0f3241eb8285dedda051a1ba-ld.mp4"; //视频预览url默认

  // 保存定时器，避免频繁写入数据
  saveDataTimer: number | null = null;

  exam: ExamV2Custom = new ExamV2Custom();
  examV3: ExamV3 = new ExamV3();
  HO: HeaderOption[] = [];
  askSubmit = false; //完成弹窗
  askCancel = false; //完成弹窗
  ask = {
    title: "",
    text: "",
    cancelBtn: "",
    okBtn: ""
  };

  companyPower: any = {}; //公司一些权限
  powerReady = false; //权限加载完毕

  //已有候选人 直接弹到第三步
  @Watch("isCandidateUsed")
  save(n: any, o: any) {
    // if (n && this.currentStep < 2) {
    //   this.showCurrentStep(2);
    // }
  }

  //禁用上一步  已有候选人 不得进入1 2步。  r2追加：抽题组卷 不得进入 12步
  get disabledPre() {
    const r1 = this.isEdit && this.isCandidateUsed && this.currentStep === 2;
    const r2 =
      this.isEdit &&
      this.exam.isRandomQuestions === 1 &&
      this.currentStep === 2;
    return r1 || r2;
  }

  async created() {
    this.loadCache();
    await this.getCompanyPower();
  }

  mounted() {
    this.dataInited = false;
    this.currentStep = 0;
    if (Number(this.$route?.query?.paperId)) {
      //编辑进入
      this.paperId = Number(this.$route.query.paperId);
      this.examGetForm.examId = Number(this.paperId);
      this.examGetForm.companyId = Number(Auth.companyId);
      this.currentStep = Number(this.$route?.query?.step ?? 0);
      this.isEdit = true;
      this.pathText = "编辑面试";
      this.getExam();
    } else {
      // 新建进入  -询问是否继续新建
      if (localStorage.getItem("aibuildercachev3")) {
        this.askGoOn = true;
      } else {
        //新建
        this.setNewExam();
      }
      this.dataInited = true;
    }
    //进入url指定对应页面 默认0
    this.showCurrentStep(this.currentStep);
    this.vuexStores.updateAiStep({ show: true, step: this.currentStep });
  }

  //获取默认的配置项
  async initHeaderOption() {
    this.HO = await ExamV3.getAllOptionList(); //所有配置项 默认值
    this.examV3.headerOptions = this.HO;
    (this.$refs.step1 as any)?.setOption();
  }

  //获取面试信息
  async getExam(getInfo = true) {
    const res = await ExamList.examGetAiV3(this.examGetForm);
    if (getInfo) {
      this.examV3 = new ExamV3().assign(res);
      // this.originScoreConfigList = this.exam.examScoreConfigList;
      this.pathText = "编辑面试-" + this.examV3.name;
    }
    this.isCandidateUsed = this.examV3.isCandidateUsed === 1;
    this.dataInited = true;
  }
  //公司权限
  async getCompanyPower() {
    await MsgRequest.getCompanyInfo(parseInt(Auth.companyId)).then(
      (res: any) => {
        if (res.code === 0) {
          this.companyPower = res.data.companySpecialConfig;
          this.powerReady = true;
        }
      }
    );
  }

  //步骤控制
  showCurrentStep(index: number) {
    this.currentStep = index;
    this.vuexStores.updateAiStep({ show: true, step: index });
    //刷新保持当前页面 -更新url
    const urlParams = this.$route.query;
    if (!urlParams?.step) {
      //url加step
      window.history.pushState(
        "",
        "",
        this.$route.fullPath + "&step=" + this.currentStep
      );
    } else {
      //url更新step
      urlParams.step = String(this.currentStep);
      let p = ``;
      for (const i in urlParams) {
        p += `${i}=${urlParams[i]}&`;
      }
      window.history.pushState(
        "",
        "",
        this.$route.path + "?" + p.substring(0, p.length - 1)
      );
    }
    this.stepShow.forEach((item: boolean, i: number) => {
      if (index === i) {
        this.$set(this.stepShow, i, true);
      } else {
        this.$set(this.stepShow, i, false);
      }
    });
  }
  //取消
  cancel() {
    if (!this.canChangePage) return;

    this.ask = {
      title: `确定要离开吗？`,
      text: `
           系统将不会保存任何${this.isEdit ? "编辑" : "创建"}面试配置，请确认`,
      cancelBtn: "取消",
      okBtn: "确认"
    };

    this.askCancel = true;
  }

  checkHasCandidateUsed() {
    // 已有候选人答题时不可更改分数
    if (this.exam.isCandidateUsed && this.originScoreConfigList) {
      this.exam.examScoreConfigList = this.originScoreConfigList;
    }
  }
  //完成
  submit() {
    //一些前置校验
    this.checkHasCandidateUsed();
    if (!(this.$refs["step2"] as any)?.checkData()) {
      return;
    }

    //开始loading
    (this.$refs.step5 as any)?.startLoading();
    this.examV3.examId = this.paperId;
    //视频默认特判
    this.examV3.publicityPageVideoUrl =
      this.examV3.publicityPageVideoUseWhich === 1
        ? this.videoUrlDef
        : this.examV3.publicityPageVideoUrl;
    //分转秒
    this.examV3.timeLimitExam = this.examV3.timeLimitExam * 60;
    //防截屏次数固定2次
    this.examV3.screenshotCheckLimit =
      this.examV3.screenshotCheck === 1 ? 2 : 0;
    ExamV3[this.isEdit ? "update" : "create"](this.examV3).then((res: any) => {
      if (res.data.code === 0) {
        this.ask = {
          title: `${this.isEdit ? "编辑" : "保存"}成功`,
          text: `面试已${
            this.isEdit ? "编辑" : "保存"
          }成功，系统生成题目视频、面试引导视频等需要一定时间，请等待5分钟后扫码参加面试`,
          okBtn: "设置管理权限",
          cancelBtn: "返回面试列表"
        };
        this.powerExamId = res.data.data.examId;
        this.askSubmit = true;
        if (!this.isEdit) {
          //新建后 清掉缓存
          setTimeout(() => {
            this.clearCache();
          }, 600);
        }
        // this.$message.success("保存成功");
      } else {
        //
      }
    });
  }
  //面试权限弹窗
  toPower() {
    //
    this.showPower = true;
  }
  //上一步
  pre() {
    if (!this.canChangePage) return;
    this.beforePageChange();
    if (this.currentStep === 0) {
      //todo 进行对应页面离开前的数据校验
    }
    if (this.currentStep === 1) {
      //todo 进行对应页面离开前的数据校验
      if (this.isEdit && this.examV3.timeLimitExamType === 2) {
        this.examV3.timeLimitExam = this.examV3.timeLimitExam * 60;
      }
    }

    this.showCurrentStep(this.currentStep - 1);
    if (this.isEdit) {
      this.getExam(false); //获取是否有人答题
    }
  }
  //下一步
  async next() {
    if (!this.canChangePage) return;
    this.beforePageChange();
    const checkDataResult = (this.$refs[
      "step" + (this.currentStep + 1)
    ] as any)?.checkData();
    if (!checkDataResult) return;
    this._next();
    if (this.isEdit) {
      await this.getExam(false); //获取是否有人答题
      this.checkHasCandidateUsed();
    }
  }
  // 防止点太快
  beforePageChange() {
    this.canChangePage = false;
    this.canCancelPage = false;
    setTimeout(() => {
      this.canChangePage = true;
    }, this.pageInterval);
    setTimeout(() => {
      this.canCancelPage = true;
    }, this.cancelInterval);
  }

  // 不检查直接下一步
  _next() {
    this.showCurrentStep(this.currentStep + 1);
  }
  back() {
    this.clearCache();
    this.$router.push("/exam/paper");
  }
  destroyed() {
    console.log("离开");
    this.vuexStores.updateAiStep({ show: false, step: 0 });
  }
  // 保存缓存
  saveCache() {
    if (this.isEdit) {
      // 编辑面试不需要保存缓存
      return;
    }
    //延迟缓存，以免自动分配分数时频繁IO
    if (this.saveDataTimer) clearTimeout(this.saveDataTimer);
    this.saveDataTimer = setTimeout(() => {
      this.saveDataTimer = null;
      localStorage.setItem("aibuildercachev3", JSON.stringify(this.examV3));
    }, 500);
  }

  loadCache() {
    const cacheJson = localStorage.getItem("aibuildercachev3");
    if (cacheJson) this.examV3 = new ExamV3().assign(JSON.parse(cacheJson));
  }

  clearCache() {
    localStorage.removeItem("aibuildercachev3");
  }
  goOn() {
    this.askGoOn = false;
  }
  //重新创建
  setNewExam() {
    this.clearCache();
    this.exam = new ExamV2Custom();
    this.examV3 = new ExamV3();
    this.initHeaderOption();
    this.$set(this.stepShow, 0, false);
    this.$nextTick(() => {
      this.$set(this.stepShow, 0, true);
    });
    this.askGoOn = false;
  }

  // 创建后提示弹窗
  submitOk() {
    this.$router.push("/exam/paper");
  }
  //取消后提示弹窗
  cancelOk() {
    if (!this.isEdit) {
      //新建 取消会清缓存
      this.clearCache();
    } else {
      //编辑 本身就无缓存
    }
    this.$router.push("/exam/paper");
  }
}
